import { z } from "zod";

export enum DictionaryCategorySchemaEnum {
	DictionaryCategory = "DictionaryCategory"
};

export const DictionaryCategorySchema = z.object({
	"@id": z.string(), // "api/dictionary_categories/1"
	"@type": z.string(), // "DictionaryCategory"
	id: z.number(), // 1
	libelle: z.string(), // "ACCESSOIRES 5.5%"
	hb_category_id: z.string(), // "1"
	hb_category_libelle: z.string(), // "Frais bancaires"
}).describe(DictionaryCategorySchemaEnum.DictionaryCategory);

export type DictionaryCategory = z.infer<typeof DictionaryCategorySchema>;
